export const MOBILE_SEND_RECOGNITION_DRAWER_KEY = 'mobileSendRecognitionDrawerKey'
